import { g as r } from "../../utils-BOfnFgIH.js";
import { I as i } from "../../constants-DeVuDy8J.js";
import { createElementBlock as d, openBlock as l, normalizeClass as o, createElementVNode as a } from "vue";
import { _ as s } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const c = {
  name: "DtIconFingerprint",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(i).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return i[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded"), this.uniqueID = r();
  }
}, _ = ["aria-label", "data-qa", "aria-hidden"], u = ["clip-path"], h = /* @__PURE__ */ a("path", { d: "M6 1.5A4.515 4.515 0 0 0 1.5 6a.5.5 0 0 1-1 0C.5 2.974 2.974.5 6 .5a5.5 5.5 0 0 1 4.4 2.2.5.5 0 0 1-.8.6A4.5 4.5 0 0 0 6 1.5Z" }, null, -1), p = /* @__PURE__ */ a("path", { d: "M3.335 4.528a.5.5 0 0 1 .307.637A2.521 2.521 0 0 0 3.5 6c0 1.54-.255 3.096-.526 3.908a.5.5 0 0 1-.948-.316C2.255 8.904 2.5 7.46 2.5 6c0-.408.07-.799.198-1.165a.5.5 0 0 1 .637-.307Zm5.608 3.974a.5.5 0 0 1 .45.546c-.038.389-.198 1.262-.258 1.56a.5.5 0 0 1-.98-.196c.06-.302.21-1.129.242-1.46a.5.5 0 0 1 .546-.45ZM4.94 4.94A1.5 1.5 0 0 1 6 4.5a.5.5 0 0 1 0 1 .5.5 0 0 0-.5.5c0 .535-.052 1.3-.133 2.053a.5.5 0 1 1-.994-.106A20.14 20.14 0 0 0 4.5 6c0-.398.158-.78.44-1.06Zm-.243 4.568a.5.5 0 0 1 .405.579 6.524 6.524 0 0 1-.245.892l-.056.173a.5.5 0 1 1-.952-.304l.067-.208c.086-.263.16-.49.202-.727a.5.5 0 0 1 .579-.405ZM7 6.06a.5.5 0 0 1 .5.5v.006c0 .593 0 1.406-.064 2.23-.064.82-.193 1.693-.472 2.39a.5.5 0 1 1-.928-.372c.221-.553.342-1.304.403-2.095A27.9 27.9 0 0 0 6.5 6.56a.5.5 0 0 1 .5-.5ZM.5 8a.5.5 0 0 1 .5-.5h.005a.5.5 0 0 1 0 1H1A.5.5 0 0 1 .5 8Zm10.3-3.49a.5.5 0 0 1 .59.39c.025.124.04.326.051.54.011.226.019.505.021.802.004.592-.012 1.282-.064 1.808a.5.5 0 0 1-.995-.1c.047-.474.063-1.123.06-1.7a18.44 18.44 0 0 0-.02-.76 3.763 3.763 0 0 0-.033-.39.5.5 0 0 1 .39-.59Z" }, null, -1), m = /* @__PURE__ */ a("path", { d: "M6 3.498a2.5 2.5 0 0 0-1.25.335.5.5 0 1 1-.5-.866A3.5 3.5 0 0 1 9.5 6H9h.5c0 .236 0 .591-.01 1.012a.5.5 0 0 1-1-.024c.01-.409.01-.753.01-.988A2.5 2.5 0 0 0 6 3.498Z" }, null, -1), f = [
  h,
  p,
  m
], g = ["id"], A = /* @__PURE__ */ a("path", {
  fill: "#fff",
  d: "M0 0h12v12H0z"
}, null, -1), Z = [
  A
];
function v(e, I, n, M, b, t) {
  return l(), d("svg", {
    "aria-label": n.ariaLabel,
    class: o([t.iconSizeClass, "d-icon d-icon--fingerprint"]),
    "data-qa": t.dataQA,
    "aria-hidden": t.ariaHidden,
    role: "img",
    "data-name": "Fingerprint",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12"
  }, [
    a("g", {
      "clip-path": `url(#${e.uniqueID}a)`,
      fill: "currentColor",
      "fill-rule": "evenodd",
      "clip-rule": "evenodd"
    }, f, 8, u),
    a("defs", null, [
      a("clipPath", {
        id: `${e.uniqueID}a`
      }, Z, 8, g)
    ])
  ], 10, _);
}
const w = /* @__PURE__ */ s(c, [["render", v]]);
export {
  w as default
};
//# sourceMappingURL=fingerprint.js.map
